function pct(n) {
  return Math.min(100, Math.max(0, n)).toFixed(1);
}

export default function UtilBar({ label, used, total, unit }) {
  const p = total > 0 ? (used / total) * 100 : 0;
  let color = "#22C55E";
  if (p > 95) color = "#EF4444";
  else if (p > 80) color = "#2563EB";

  return (
    <div>
      <div className="flex justify-between mono text-[11px] mb-1">
        <span className="text-[#64748B] uppercase tracking-wider">{label}</span>
        <span className="text-white">
          {used.toLocaleString(undefined, { maximumFractionDigits: 1 })} / {total.toLocaleString()} {unit}
          <span className="text-[#64748B] ml-2">{pct(p)}%</span>
        </span>
      </div>
      <div className="h-1.5 bg-slate-100 relative overflow-hidden">
        <div
          className="h-full util-bar-fill transition-[width] duration-500"
          style={{ width: `${pct(p)}%`, background: color }}
        />
      </div>
    </div>
  );
}
